package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div

@Composable
fun CardGrid(
    modifier: Modifier = Modifier,
    minColumnPx: Int = 260,
    gapPx: Int = 24,
    content: @Composable () -> Unit,
) {
    Div(
        attrs = Modifier
            .styleModifier {
                property("width", "100%")
                property("display", "grid")
                property("grid-template-columns", "repeat(auto-fit, minmax(${minColumnPx}px, 1fr))")
                property("gap", "${gapPx}px")
                property("align-items", "stretch")
                property("justify-items", "stretch")
            }
            .then(modifier)
            .toAttrs(),
    ) {
        content()
    }
}

@Composable
fun ContactCardGrid(content: @Composable () -> Unit) {
    Div(
        attrs = Modifier.classNames("sb-contact-grid").toAttrs(),
    ) {
        content()
    }
}
